






















































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import { mapGetters } from 'vuex';

@Component
export default class AdminNavigation extends Vue {
  private logo: string = '/img/logo.png';
  private sidebarImage: string = '/img/dog_sidebar.jpg';
  private items: any = [
    {
      icon: 'dashboard',
      text: 'Dashboard',
      route: 'AdminDashboard',
    },
    {
      icon: 'people_outline',
      text: 'Moderators',
      route: 'AdminModerators',
    },
    {
      icon: 'group',
      text: 'Users',
      route: 'AdminUsers',
    },
    {
      icon: 'pets',
      text: 'Animals',
      route: 'AdminAnimals',
    },
    {
      icon: 'pets',
      text: 'Posts',
      route: 'AdminPosts',
    },
  ];
  private responsive: boolean = false;

  @Getter('common/ui/sidebar') private storeSidebar!: boolean;
  @Mutation('common/ui/setSidebar') private setSidebar!: any;

  get sidebar() {
    return this.storeSidebar;
  }

  set sidebar(value: any) {
    this.setSidebar(value);
  }
}
